import { render, staticRenderFns } from "./RecoverPasswordForm.vue?vue&type=template&id=742a9f72&lang=pug"
import script from "./RecoverPasswordForm.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./RecoverPasswordForm.vue?vue&type=style&index=0&id=742a9f72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports